<template>
<svg viewBox="0 0 16 16" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-line-subtract`]" width="1em" height="1em" v-bind="$attrs"><path d="M13.332 7C13.6993 7 13.9971 7.29777 13.9971 7.66504C13.9969 8.03213 13.6992 8.33007 13.332 8.33008H2.66504C2.29804 8.32991 2.00021 8.03203 2 7.66504C2 7.29787 2.29791 7.00017 2.66504 7H13.332Z"/></svg>
</template>
<script>

export default {
  name: 'IconLineSubtract',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
